import { useQuery } from 'react-query';
import { AxiosError } from 'axios';

import { ONE_HOUR } from '@constants';
import { PartnerCategory, PartnerCategoriesResponse } from '@common/types/api';
import { api } from '@services';

const fetchPartnerCategories = () =>
  api
    .get<PartnerCategoriesResponse>('/partners/categories?limit=100')
    .then(({ data }) => data.data);

export const usePartnerCategoriesQuery = () =>
  useQuery<PartnerCategory[], AxiosError>(
    ['partner-categories'],
    fetchPartnerCategories,
    {
      staleTime: ONE_HOUR * 24,
    },
  );
